import set from "@rill/set";
import { ReportsMenu } from "./ReportsMenu";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import _ from "lodash";

const ReportsMenuController = (app) => {
  app.get(
    "/reports-menu",
    set("heading", "Reports Menu"),
    async ({ req, res, locals }) => {
      const { query } = locals;
      const modal = _.get(query, "modal", {});
      locals.modal = {
        "activity-feed": <ActivityDrawer />,
      }[modal.type];
      res.body = <ReportsMenu locals={locals} />;
    }
  );
};

export default ReportsMenuController;
